import { validateEmail } from '../Shared/validations.js';
import { copyFor } from '../../copy/copy';

const validatePrefix = values => {
    if (values.prefix == null || values.prefix === '') {
        return { prefix: ' ' };
    }
    return {};
};

const validateFullName = values => {
    if (values.fullName == null || values.fullName === '') {
        return { fullName: copyFor('validationErrors', 'fullName', 'petition') };
    }
    const split = values.fullName.split(' ');

    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName', 'petition') };
};

const validateMessage = values => {
    if (values.message == null || values.message === '') {
        return { message: copyFor('validationErrors', 'message', 'petition') };
    }
    return {};
};

const validatePostalCode = values => {
    if (values.postalCode == null || values.postalCode === '') {
        return { postalCode: ' ' };
    }
    return {};
};

const validate = values => {
    const errors = {
        ...validatePrefix(values),
        ...validateFullName(values),
        ...validateEmail(values),
        ...validateMessage(values),
        ...validatePostalCode(values)
    };

    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/Petition/validations.js